import React from 'react'
import { DiscountVoucher } from 'src/core/models'
import { CustomLink, CustomText } from 'src/components'

const DiscountVoucherEmailColumn: React.FC<{ discount: DiscountVoucher }> = ({ discount }) => {
  return discount.is_linked_to_email ? (
    <CustomLink
      link={`mailto:${discount.email}`}
      label={discount.email}
      showIcon={false}
      isSmallText
    />
  ) : (
    <CustomText
      label='-'
      type='secondary'
      className='centered'
    />
  )
}

export default DiscountVoucherEmailColumn
